import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import logo from "../../../assets/Images/LoginLogo.svg";
import tickIcon from "../../../assets/icons/tick.svg";
import "../../../assets/css/page/Auth.scss";
const benefits = [
  { text: "Scalable Outreach" },
  { text: "Superior Efficiency" },
  { text: "Dedicated support" },
];

const AuthLayout = ({ children }) => {
  return (
    <Grid container className="auth-container">
      <Grid
        className="left-section"
        size={{
          md: 6.5,
        }}
      >
        <Box component="img" src={logo} alt="Logo" className="logo" />

        <Box className="text-box">
          <Typography
            color="white"
            sx={{
              fontSize: { xs: 30, lg: 40 },
              fontWeight: 500,
            }}
          >
            AI Voice Agents
          </Typography>
          <Typography
            color="white"
            sx={{
              fontSize: { xs: 30, lg: 40 },
              fontWeight: 500,
            }}
          >
            Redefining Enterprise Outreach.
          </Typography>

          <Box className="border-bottom" />

          <Box className="benefits-list">
            {benefits.map((benefit, index) => (
              <Typography
                key={index}
                className="benefit-item"
                sx={{
                  fontSize: 14,
                }}
              >
                <img src={tickIcon} height={16} width={16} alt="tick" />
                {benefit.text}
              </Typography>
            ))}
          </Box>
        </Box>
      </Grid>
      <Grid
        className="right-section"
        size={{
          xs: 12,
          md: 5.5,
        }}
      >
        {children}
      </Grid>
    </Grid>
  );
};

export default AuthLayout;
